import Header from "./header";
import { PortalFooter } from "../../footer";
import { ILayout } from "./types";
import { NORNE_CENTERID } from "@portal/assets/banks";

const LayoutNotAuthorized = ({ children, centerId }: React.PropsWithChildren<ILayout>) => (
  <div className="flex flex-col w-full bg-portalBackgroundColor dark:bg-gray-900 min-h-screen">
    <div className="border-b dark:border-b-greyDark print:hidden bg-headerBackground text-headerMenuText dark:bg-gray-950 dark:text-headerMenuTextDark">
      <Header centerId={centerId ?? NORNE_CENTERID} />
    </div>
    <div className="container mx-auto md:my-4">{children}</div>
    <PortalFooter centerId="" />
  </div>
);

export default LayoutNotAuthorized;
